var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "land_addon" },
    [
      _c("standart", {
        key: "land_addon",
        attrs: {
          title: "Продаж земельної ділянки співробітнику ІМК",
          is_active_result: false,
          is_active_problem: false,
        },
      }),
      _vm._v(" "),
      _vm.addon
        ? _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c("h1", { staticClass: "title text-center pt-5 pb-5 mt-5" }, [
                _vm._v("\n            Інформація про лот\n        "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "main_info" },
                [
                  _vm._l(this.pull_pai_fields, function (field) {
                    return _c(
                      "b-row",
                      { key: field.id, staticClass: "doc_title" },
                      [
                        _c("b-col", { attrs: { sm: "3" } }, [
                          _c(
                            "label",
                            { attrs: { for: field.type + field.id } },
                            [_vm._v(_vm._s(field.name) + " ")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "4" } },
                          [
                            field.type === "string_input"
                              ? _c("b-form-input", {
                                  staticClass: "fs-xl",
                                  attrs: {
                                    type: "text",
                                    state: _vm.is_valid_field(field),
                                    id: field.type + field.id,
                                    size: "sm",
                                  },
                                  model: {
                                    value: field.value,
                                    callback: function ($$v) {
                                      _vm.$set(field, "value", $$v)
                                    },
                                    expression: "field.value",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            field.type === "yes_no"
                              ? _c("b-form-radio-group", {
                                  attrs: {
                                    id: "btn-radios-1",
                                    "button-variant": "outline-primary",
                                    options: _vm.addon_options,
                                    name: "radios-btn-default",
                                    buttons: "",
                                  },
                                  model: {
                                    value: field.value,
                                    callback: function ($$v) {
                                      _vm.$set(field, "value", $$v)
                                    },
                                    expression: "field.value",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.cur_choice_val === "hand"
                    ? _c(
                        "b-row",
                        { staticClass: "mt-3 mb-3 doc_title" },
                        [
                          _c("b-col", { attrs: { sm: "3" } }, [
                            _c("label", [_vm._v("Погоджувач")]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              !this.obj_to_null(this.adjust_user)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "add user cursor-pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.add_user("adjust")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa add_user fa-plus-square",
                                        attrs: {
                                          title: "",
                                          "data-type": "delegate_users",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Оберіть користувача"),
                                      ]),
                                    ]
                                  )
                                : _c("user_block", {
                                    key: this.adjust_user.value.id,
                                    attrs: {
                                      can_del: true,
                                      del_triger: "remove_adjust",
                                      user: this.adjust_user.value,
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cur_choice_val === "hand"
                    ? _c(
                        "b-row",
                        { staticClass: "mt-3 mb-3 doc_title" },
                        [
                          _c("b-col", { attrs: { sm: "3" } }, [
                            _c("label", [_vm._v("Виконавець")]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              !this.obj_to_null(this.recipient_user)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "add user cursor-pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.add_user("worker")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa add_user fa-plus-square",
                                        attrs: {
                                          title: "",
                                          "data-type": "delegate_users",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Оберіть користувача"),
                                      ]),
                                    ]
                                  )
                                : _c("user_block", {
                                    key: this.recipient_user.value.id,
                                    attrs: {
                                      can_del: true,
                                      del_triger: "remove_recipient",
                                      user: this.recipient_user.value,
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-tabs",
                {
                  attrs: { "content-class": "mt-3" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "tabs-end",
                        fn: function () {
                          return [
                            _c(
                              "b-nav-item",
                              {
                                attrs: { role: "presentation", href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.add_pull_pai.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v("\n                    Додати "),
                                _c("b", [_vm._v("+")]),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2176000887
                  ),
                },
                _vm._l(this.pull_pai_items, function (tab, index) {
                  return _c(
                    "b-tab",
                    {
                      key: index,
                      attrs: {
                        "active-nav-item-class":
                          "font-weight-bold text-uppercase text-danger",
                        active: tab.is_active,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.set_active(tab)
                        },
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "title" },
                        [
                          _c("div", { staticClass: "icon-stack fs-xxl" }, [
                            _c("i", {
                              staticClass:
                                "base base-7 icon-stack-2x opacity-100 color-primary-500",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "fal fa-globe-americas icon-stack-1x opacity-100 color-white",
                            }),
                          ]),
                          _vm._v(
                            "\n                    \n                    " +
                              _vm._s(_vm.get_tab_title(index)) +
                              "\n                    \n                    "
                          ),
                          tab.is_load
                            ? _c("b-spinner", {
                                attrs: { type: "grow", small: "" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          index > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "icon-stack fs-xxl cursor-pointer ml-3",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.remove_tab(index)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fal fa-trash-alt icon-stack-1x opacity-100 color-danger-500",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("land_pai", {
                        key: "pai_" + index,
                        attrs: { owner_field: _vm.owner_field, pai_item: tab },
                      }),
                    ],
                    2
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }